import { render } from "./Uploading.vue?vue&type=template&id=a40f1748"
import script from "./Uploading.vue?vue&type=script&lang=js"
export * from "./Uploading.vue?vue&type=script&lang=js"
script.render = render

export default script